import React, { useEffect, useState } from 'react';

const AccordionSection = ({ title, data, fields, profileDetails, profileDetailsGEO, defaultExpanded = false }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);


  const toggle = () => setExpanded(!expanded);

  return (
    <div className="accordion-section">
      <div
        className={`accordion-header ${expanded ? 'expanded' : ''}`}
        onClick={toggle} >
        {title}
      </div>
      {expanded && (
        <table>
          <tbody>
            {Object.entries(fields).map(([key, label]) => (
              <tr key={key}>
                <th>{label}</th>
                <td>
                  {key === "photo" ? (
                    <img
                      src={`https://urbangis.mp.gov.in/api/DownloadImage?Relation_Id=${profileDetails.relation_id}`}
                      alt=""
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  )
                    : key === "ward" ? (
                      `${data.wardno || ""} - ${data.wardname || ""}`.trim() || "—"
                    )
                      : key === "landusetype" ? (
                        <label
                          style={{
                            fontSize: "14px",
                           // fontFamily: "Arial, sans-serif", // or any preferred font
                            // fontFamily: "Arial", // or any preferred font
                         //   textTransform: "uppercase",
                            marginBottom: "8px",
                          }}
                        >
                          {profileDetails.landusetype}
                        </label>
                      )

                        : key === "floor_details" ?
                          (
                            data.floor_details ? (
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  marginTop: "10px",
                                }}
                              >    <tr>
                                  <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    S.NO
                                  </th>
                                  <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    Floor
                                  </th>
                                  <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    Area (Sqft)
                                  </th>
                                  <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    Construction Type
                                  </th>
                                  <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    Usage Type
                                  </th>
                                  <th style={{ border: "1px solid #ddd", padding: "4px" }}>
                                    Usage Factor
                                  </th>
                                </tr>
                                <tbody>
                                  {data.floor_details
                                    .split("|")
                                    .filter((f) => f.trim() !== "")
                                    .map((item, idx) => {
                                      const obj = {};
                                      item.split(",").forEach((pair) => {
                                        const [k, v] = pair.split(":").map((s) => s.trim());
                                        if (k && v) obj[k] = v;
                                      });
                                      return (
                                        <tr key={idx}>
                                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                            {idx + 1 || "—"}
                                          </td>
                                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                            {obj.Floor || "—"}
                                          </td>
                                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                            {obj.Area || "—"}
                                          </td>
                                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                            {obj.ConsType || "—"}
                                          </td>
                                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                            {obj.UsageType || "—"}
                                          </td>
                                          <td style={{ border: "1px solid #ddd", padding: "4px" }}>
                                            {obj.UsageFactor || "—"}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            )

                              //   :key === "MasterPlan Landuse" ? (
                              //       profileDetails.land_use_status
                              // ) 
                              :
                              (
                                "—"
                              )
                          ) : (
                            data[key] || "0"
                          )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

const ParcelInfoComponent = ({ relationIdToQuery, gis_uniqueid, profileDetails, profileDetailsGEO }) => {
  const [parcelData, setParcelData] = useState({});
  const [loading, setLoading] = useState(true);

  const endpoints = {

    //Card 1
    property_parcel_info:
    {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97/query",
      buildWhere: ({ relation_id, e_nagarpalikaid, dist_cd, ulb_cd, wardno }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'  AND wardno='${wardno}' AND relation_id='${relation_id}' AND e_nagarpalikaid='${e_nagarpalikaid}' `,
      fields: {
        photo: "Photo",
        relation_id: "Relation ID",
        e_nagarpalikaid: "E-Nagarpalika ID",
        ownername: "Owner Name",
        mobileno: "Mobile No.",
      },
      title: "Property Parcel Info",
    },

    // Card 2
    mis_details: {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97/query",
      buildWhere: ({ relation_id, e_nagarpalikaid, dist_cd, ulb_cd, wardno }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'  AND wardno='${wardno}' AND relation_id='${relation_id}' AND e_nagarpalikaid='${e_nagarpalikaid}' `,
      fields: {
        gis_uniqueid: "GIS Unique ID",
        divisionname: "Division", districtname: "District", ulbname: "ULB",

        //wardno: "Ward NO",
        ward: "Ward",
        electricity_id: "Electricity ID",
        pownershipdetails: "Property Ownership",
        constructiontype: "Construction Type",
        plotsize: "Plot Size in Sqft",
        plintharea: "Plinth Area in Sqft",
        nooffloor: "No of Floor",
        ta_builtuparea: "Total Builtup area",
        taxzonename_e: "Tax Rate Zone",
        wsconnno: "Water Connection ID",
        ihtoiletyn: "Connected to Sewer",
        swmd2d: "SW Door to Door Collection",
        landusetype: "Property Use",
      },
      title: "MIS Details",

    },


    // Card 3
    owner_details: {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/96/query",
      buildWhere: ({ relation_id, e_nagarpalikaid, dist_cd, ulb_cd, wardno }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'  AND wardno='${wardno}' AND relation_id='${relation_id}' AND e_nagarpalikaid='${e_nagarpalikaid}' `,
      fields: {
        gis_uniqueid: "GIS Unique ID",
        ownername: "Owner Name",
        ownergardianname: "Guardian Name",
        mobileno: "Mobile No.",
        address: "Address"

      },
      title: "Owner Details",
    },

    // Card 4
    Floor_details: {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/view_mis_data/MapServer/97/query",
      buildWhere: ({ relation_id, e_nagarpalikaid, dist_cd, ulb_cd, wardno }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'  AND wardno='${wardno}' AND relation_id='${relation_id}' AND e_nagarpalikaid='${e_nagarpalikaid}' `,

      fields: {
        // floor_details:''
        // gis_uniqueid: "GIS Unique ID",
        floor_details: "Floor Details"
        /*
        Floor: GF,
        Area: 900.00,
        ConsType: RCC,
        UsageType: Residential, 
        UsageFactor: Self
        */
      },
      title: "Floor Details",
    },

    //Card 5 
    /*  // code for INSIDE  fetchTaxInsights BHUPEN ENP API 10 APRIL
         ENPAPI
       */
  Tax_insights: {
  fields: {
     ass_year: "Assessment Year",
    arrear: "Arrear",
    current_year_tax: "Current Year Tax",   
    net_total: "Net Total",
    total: "Total Tax Due",

  },
  title: "Tax Insights"
},

    //Card 5 
    /*
        https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer/1/query?where=relation_id=%2701150300576%27&outFields=*&f=json
        dist_cd="458" , ulb_cd="0115" , "03",
        
        */
    tax_evaluation: {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/tax_evaluation/MapServer/1/query",
      buildWhere: ({ relation_id, e_nagarpalikaid, dist_cd, ulb_cd, wardno, gis_uniqueid }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'  AND wardno='${wardno}' AND relation_id='${relation_id}' AND gis_uniqueid='${gis_uniqueid}' AND e_nagarpalikaid='${e_nagarpalikaid}' `,
      fields: {
        relation_id: "Relation ID",
        e_nagarpalikaid: "E-Nagarpalika ID",
        propertyvalue: "Property Value as per SAMPADA",
        ptaxvalue: "Property Tax (ENP)",
        act_ptaxvalue: "Property Tax (Actual)",
        levied_value: "Difference",
        tax_status: "Taxation Status"
      },
      title: "Tax Evaluation"
    },

    //Card 6 


    ABPas_property: {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/abpas_property_mview/MapServer/1/query",
      buildWhere: ({ relation_id, e_nagarpalikaid, dist_cd, ulb_cd, wardno, gis_uniqueid }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'  AND wardno='${wardno}' AND relation_id='${relation_id}' AND gis_uniqueid='${gis_uniqueid}' AND e_nagarpalikaid='${e_nagarpalikaid}' `,
      fields: {
        relation_id: "Relation ID",
        e_nagarpalikaid: "E-Nagarpalika ID",
        gis_builtup_area_sqft: "GIS Builtup Area",
        abpas_builtup_area_sqft: "ABPAS Builtup Area",
        diff_builtup_area_sqft: "Diff Builtup",
        gis_plot_area_sqft: "GIS Plot Area",
        abpass_plot_area_sqft: "ABPAS Plot Area",
        diff_plot_area_sqft: "Diff Plot Area",
        gis_no_of_floors: "GIS No of Floors",
        abpas_no_of_floors: "ABPAS No of Floors",
        floor_status: "Floor Status",
        gis_land_use_type: "GIS Landuse Type",
        abpas_land_use_type: "ABPAS Landuse Type",
        land_use_status: "Landuse Status"



      },
      title: "ABPAS vs MPHS Comparison"
    },
    //Card 7 

    // alert(` profileDetailsGEO DATA  ${ profileDetailsGEO }`);

    MasterPlan: {
      url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer/3/query",
      buildWhere: ({ dist_cd, ulb_cd }) =>
        `dist_cd='${dist_cd}' AND ulb_cd='${ulb_cd}'`,
      geometry: profileDetailsGEO,
      spatialRelationship: "intersects",


      fields: {
      
          landusetype: "Property Landuse",
          land_use: "MasterPlan Landuse",
      },
      title: "Property vs Master Plan Landuse"
    },


  };


  useEffect(() => {

    if (
      !profileDetails?.relation_id ||
      !profileDetails?.e_nagarpalikaid ||
      !profileDetails?.dist_cd ||
      !profileDetails?.ulb_cd ||
      !profileDetails?.wardno
    ) {
      return; // Wait for all required fields
    }

         
// ENPAPI  code for INSIDE  fetchTaxInsights BHUPEN ENP API 10 APRIL
const fetchTaxInsights = async (e_nagarpalikaid) => {
  try {
    const res = await fetch(
      "https://urbangis.mp.gov.in/api/ENP/ENPPropertyDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          enagarpalika_Id: e_nagarpalikaid,
        }),
      }
    );

    const json = await res.json();

    if (json.status === "success" && json.data) {
      const data = json.data;

      const getFinancialYear = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // Jan = 0

  if (month >= 4) {
    return `${year}-${String(year + 1).slice(-2)}`;
  } else {
    return `${year - 1}-${String(year).slice(-2)}`;
  }
};
      return {       
        arrear: data.arrear ?? "0",
       ass_year: data.ass_year ?? getFinancialYear(),
        current_year_tax: data.current_year_tax ?? "0",
        net_total: data.net_total ?? "0",
        total: data.total ?? "0",
        
      };
    }

    return {};
  } catch (err) {
    console.error("Tax Insights API Error:", err);
    return {};
  }
};
// code for INSIDE





    const fetchAllData = async () => {
      try {
       const results = await Promise.all(
  Object.entries(endpoints).map(async ([key, config]) => {

    // ✅ HANDLE TAX INSIGHTS SEPARATELY
    if (key === "Tax_insights") {
      const taxData = await fetchTaxInsights(profileDetails.e_nagarpalikaid);
      return [key, taxData];
    }

    let whereClause = "";
    if (config.buildWhere) {
      whereClause = config.buildWhere({
        dist_cd: profileDetails.dist_cd,
        ulb_cd: profileDetails.ulb_cd,
        wardno: profileDetails.wardno,
        gis_uniqueid: profileDetails.gis_uniqueid,
        e_nagarpalikaid: profileDetails.e_nagarpalikaid,
        relation_id: profileDetails.relation_id,
      });
    }

    const params = new URLSearchParams({
      where: whereClause,
      outFields: "*",
      f: "json",
    });

    const res = await fetch(`${config.url}?${params.toString()}`);
    const json = await res.json();

    const attributes = json?.features?.[0]?.attributes || {};

    // ✅ MIS DETAILS (already yours)
    if (key === "mis_details") {
      const wardNo = attributes.wardno || "";
      const wardName = attributes.wardname || "";
      attributes.ward = wardNo && wardName
        ? `${wardNo} - ${wardName}`
        : wardNo || wardName || "";
    }

    // ✅ OWNER DETAILS (already yours)
    if (key === "owner_details") {
      const colony = attributes.colony || "";
      const city = attributes.city || "";
      const pin = attributes.pin || "";

      attributes.address =
        colony && city && pin
          ? `${colony}, ${city}, Pin-${pin}`
          : colony || city || pin || "";
    }

    return [key, attributes];
  })
);
        setParcelData(Object.fromEntries(results));
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };


    fetchAllData();
  }, [relationIdToQuery, gis_uniqueid, profileDetails, profileDetailsGEO]);

  return (
    <div>
      <style>{`
        .accordion-section {
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-bottom: 10px;
          margin-top: 10px;
          border-radius: 10px;
        }
        .accordion-header {
          position: relative;
          background: linear-gradient(175deg, #292548 3.41%, #03856E 95.82%);
            color: white; 
                
          cursor: pointer;
          padding: 10px 15px;
          padding-right: 30px;
          user-select: none;
         // font-weight: bold;
          border-radius: 10px;
        }
        .accordion-header:hover {
          background: linear-gradient(175deg, #292548 3.41%, #03856E 95.82%);
            color: white;  
        }
        .accordion-header::after {
          content: "";
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%) rotate(0deg);
          border-style: solid;
          border-width: 6px 4px 0 4px;
          border-color: white transparent transparent transparent;
          transition: transform 0.3s ease;
        }
        .accordion-header.expanded::after {
          transform: translateY(-50%) rotate(180deg);
        }
        .accordion-content {
          padding: 0;
          background: #f9f9f9;
          
        }
        table {
          width: 100%;
          border-collapse: collapse;
        }
        td, th {
          padding: 8px 12px;
          border-bottom: 1px solid #ddd;
          vertical-align: top;
        }
        th {
          background: #f1f1f1;
          text-align: left;
          width: 40%;
        }
      `}</style>

      {/* <h4 style={{ fontFamily: 'Arial', margin: '20px 0' }}>MIS Details</h4> */}

      {loading ? (
        <div>Loading data...</div>
      ) : (
        Object.entries(endpoints).map(([key, config]) => (
          <AccordionSection
            key={key}
            title={config.title}
            data={parcelData[key] || {}}
            fields={config.fields}
            profileDetails={profileDetails}
            profileDetailsGEO={profileDetailsGEO}
            defaultExpanded={config.title === "Property Parcel Info"}
          />
        ))
      )}
    </div>
  );
};

export default ParcelInfoComponent;
